import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://usaebookpoint.shop/cart/54943862129012:1';
type PurchaseButtonProps = {
  className?: string;
  label?: string;
};
export function PurchaseButton({
  className = '',
  label = 'Quiero mi kit RRHH ahora'
}: PurchaseButtonProps) {
  return <a className={`purchase-button ${className}`} href={CHECKOUT_URL} target="_blank" rel="noreferrer" aria-label={`${label}. Abre la página de pago`} data-id="element-40" data-mp="31frpckjmhww">
      <span data-id="element-41" data-mp="vpbp6jhxsduq">{label}</span>
      <ArrowUpRightIcon size={19} aria-hidden="true" data-id="element-42" data-mp="vok2xza8bsh4" />
    </a>;
}